module.exports = __webpack_public_path__ + "img/ic_qu_next_on.54817823.svg";